<div>
  <div class="mat-h3">
    Schnittstellenkonfiguration
  </div>
  <p>
    In diesem Bereich müssen die relevanten Schnittstellen zu den von Ihnen genutzten Buchhaltungssystemen eingerichtet
    werden.
  </p>
  <ul>
    <li>
      <div class="mat-h3">
        Diamant
      </div>
      <ul>
        <li>
          <div class="mat-h4">Belegart</div>
          <p>
            Kennzeichnet die Art des Belegs. Geben Sie hier das Schnittstellenkennzeichen einer Belegart der Diamant
            Finanzbuchhaltung an.
          </p>
        </li>

        <li>
          <div class="mat-h4">Belegart Gutschrift</div>
          <p>
            Die Belegart Gutschrift ist ein spezieller Belegtyp, der für Rückerstattungen oder Gutschriften verwendet
            wird.
            Sie dient dazu, Gutschriften korrekt von anderen Belegarten abzugrenzen und im System entsprechend zu
            buchen.
          </p>
        </li>

        <li>
          <div class="mat-h4">Erweiterter F-Datensatz</div>
          <p>
            Zusatzfelder mit Kundeninformationen werden automatisch ausgefüllt. Diese Felder umfassen: Geburtsdatum,
            Versicherungsnummer, Patientenname, Startort, Einsatzdatum und Zielort.
          </p>
        </li>

        <li>
          <div class="mat-h4">Rechnungsdatum als Belegdatum</div>
          <p>
            Wenn diese Option aktiviert ist, wird das Rechnungsdatum als Belegdatum verwendet. Ist die Option
            deaktiviert, wird stattdessen das Leistungsdatum als Belegdatum herangezogen.
          </p>
        </li>

        <li>
          <div class="mat-h4">S-Datensatz-Export</div>
          <p>
            Ist diese Option aktiv, werden die Debitoren-Stammdatenänderungssätze für Personenkonten exportiert.
          </p>
        </li>

        <li>
          <div class="mat-h4">Mahnart</div>
          <p>
            Dem Konto kann eine Mahnart zugeordnet werden. Ist die hier übergebene Mahnart in Diamant nicht angelegt
            oder wird ein Leerzeichen in Hochkommas (" ") übergeben, weist das System dem Konto die Standardmahnart zu
            und schreibt dies in ein Fehlerprotokoll. Die übergebene Mahnart bzw. die Standardmahnart muss in Diamant
            angelegt sein. Wird hier eine Mahnart angegeben, so wird diese für alle Personenkonten übernommen.
          </p>
        </li>

        <li>
          <div class="mat-h4">Zahlungskondition</div>
          <p>
            Dem Konto kann eine Zahlungskondition zugeordnet werden. Ist die hier übergebene Zahlungskondition in
            Diamant nicht angelegt oder wird ein Leerzeichen in Hochkommas (" ") übergeben, weist das System dem Konto
            die Standardzahlungskondition zu und schreibt dies in ein Fehlerprotokoll. Die übergebene Zahlungskondition
            bzw. die Standardzahlungskondition muss in Diamant angelegt sein. Wird hier eine Zahlungskondition
            angegeben, so wird diese für alle Personenkonten übernommen.
          </p>
        </li>
      </ul>
    </li>
    <li>
      <div class="mat-h3">
        EXTF
      </div>
      <ul>
        <li>
          <div class="mat-h4">Spaltenbezeichnung hinzufügen</div>
          <p>
            Fügt bei Aktivierung dem CSV-Export eine Zeile mit Spaltenbezeichnungen nach den Spaltentiteln vor den
            Zeilen mit den eigentlichen Buchungssätzen hinzu.
          </p>
        </li>
        <li>
          <div class="mat-h4">Beraternummer</div>
          <p>
            Die Beraternummer ist eine eindeutige Identifikationsnummer, die dem externen Berater oder Dienstleister
            zugeordnet wird. Sie dient der Zuordnung von Buchungsvorgängen und Abrechnungen zu den jeweiligen Beratern
            innerhalb der EXTF-Schnittstelle.
          </p>
        </li>
        <li>
          <div class="mat-h4">Sachkontenlänge</div>
          <p>
            Die Sachkontenlänge definiert die maximale Anzahl an Zeichen, die für Sachkonten im Buchungssystem zulässig
            sind. Sie stellt sicher, dass die Buchungssätze korrekt auf die jeweiligen Sachkonten zugeordnet werden und
            dass die Kontonummern im richtigen Format hinterlegt werden.
          </p>
        </li>
      </ul>
    </li>
    <li>
      <div class="mat-h3">
        Micos
      </div>
      <ul>
        <li>
          <div class="mat-h4">Abstimmkreis</div>
          <p>
            Der Abstimmkreis dient der organisatorischen und abrechnungstechnischen Zuordnung von Buchungsvorgängen.
            Hier wird die Verbindung zu den relevanten Abstimmkreisen des Buchhaltungssystems hergestellt. </p>
        </li>
        <li>
          <div class="mat-h4">Kostenstelle</div>
          <p>
            Die angegebene Kostenstelle wird als Standardkostenstelle für alle Buchungssätze in Micos verwendet.
            Die im Mapping definierten Kostenstellen werden als Kostenträger in die Buchungsdatei eingetragen. </p>
        </li>
      </ul>
    </li>
  </ul>
</div>
